import React from "react";
import moment from "moment";
import { Icon } from "@iconify/react";
import "./Interaction.css";

const Interaction = ({ data }) => {
  console.log("interaction", data);

  const renderInteractionIcon = (phoneTypeID) => {
    let backgroundColor;
    let icon;

    switch (phoneTypeID) {
      case 0:
        backgroundColor = "#727272";
        icon = "mdi:eye-check";
        break;

      case 1:
        backgroundColor = "#BA68C8";
        // icon = "ic:baseline-local-phone";
        icon = "mdi:briefcase";
        break;

      // case 2:
      //   backgroundColor = "#FF9800";
      //   icon = "material-symbols:mail-rounded";
      //   break;

      // case 5:
      //   backgroundColor = "#3F80FF";
      //   icon = "ph:chat-dots-fill";
      //   break;

      case 9:
      case 10:
        backgroundColor = "#4CAF50";
        // icon = "ic:baseline-whatsapp";
        icon = "ic:baseline-local-phone";
        break;

      default:
        break;
    }

    return (
      <div className="item-icon" style={{ backgroundColor: backgroundColor }}>
        <Icon height="24" icon={icon} width="24" />
      </div>
    );
  };

  return (
    <div className="interaction">
      {data.length ? (
        <div className="container-timeline">
          <div className="timeline">
            {data.map((interaction, index, arr) => {
              /* let decodedHTML = decodeHTML(interaction.Description); */

              return (
                <React.Fragment key={index}>
                  {/* Compare dates, if current message date value is equal as previous message date value, don't show the date component. Except for the first message, which is always shown */}
                  {(!moment
                    .utc(interaction.InteractionTime)
                    .isSame(
                      moment.utc(arr[index - 1]?.InteractionTime),
                      "date"
                    ) ||
                    index === 0) && (
                    <div className="date">
                      {moment
                        .utc(interaction.InteractionTime)
                        .format("DD MMM YYYY")}
                    </div>
                  )}

                  <div
                    className="item-container"
                    key={interaction.interactionID}
                  >
                    {renderInteractionIcon(interaction.PhoneTypeID)}

                    <div className="item">
                      <header>
                        {/* <p className="name">{interaction.AgentName}</p> */}

                        <div className="right">
                          {interaction.PhoneTypeID === 9 && ( // Only show for whatsapp
                            <button
                              className="show-chat-button"
                              style={{ backgroundColor: "#4CAF50" }}
                            >
                              Action
                            </button>
                          )}

                          <div className="time">
                            <Icon
                              icon="mingcute:time-line"
                              width="18"
                              height="18"
                            />

                            <p>
                              {moment
                                .utc(interaction.InteractionTime)
                                .format("HH:mm")}
                            </p>
                          </div>
                        </div>
                      </header>

                      <p
                        className="message"
                        // dangerouslySetInnerHTML={{
                        //   // Sanitize HTML to increase security against XSS attacks
                        //   __html: DOMPurify.sanitize(
                        //     decodedHTML
                        //       ? decodedHTML
                        //       : interaction.Description,
                        //     {
                        //       USE_PROFILES: { html: true },
                        //     }
                        //   ),
                        // }}
                      >
                        {interaction.InteractionStatus}
                      </p>

                      {/* {attachmentinteraction.find(
                        (file) => file.interactionID === interaction.interactionID
                      ) && (
                        <div className="attachments">
                          <p>Attachments:</p>

                          <div className="file-list">
                            {attachmentinteraction
                              .filter(
                                (file) =>
                                  file.interactionID === interaction.interactionID
                              )
                              .map((filteredFile) => {
                                return (
                                  <div className="file">
                                    <a
                                      download
                                      href={`//192.168.1.8/d$/CS/Web4/CenterixChat/frontend/uploads/${filteredFile.Name}`}
                                    >
                                      <IconButton>
                                        <Icon
                                          height="18"
                                          icon="ic:baseline-download"
                                          width="18"
                                        />
                                      </IconButton>
                                    </a>

                                    <p>{filteredFile.Name}</p>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      )} */}
                    </div>
                  </div>
                </React.Fragment>
              );
            })}

            <div className="item-container">
              <div className="item-icon" style={{ backgroundColor: "#727272" }}>
                <Icon
                  height="24"
                  icon="icon-park-outline:stopwatch-start"
                  width="24"
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p className="no-interaction">No interaction found</p>
      )}
    </div>
  );
};

export default Interaction;
